<template>
    <div>
        请耐心等待
        {{$store.state.modal.semester_id}}
    </div>
</template>

<script>
    export default {
        name: "Dialog_TimeTableExcel",
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleExcel();
        },
        methods: {
            handleExcel() {
                window.open('http://localhost:5200/timeTableExcel?semester_id='+this.$store.state.modal.semester_id);
                // this.$wApi.send(this.$parentInfo.path, 'timeTableExcel', {
                //     'semester_id': this.$store.state.modal.data.semester_id,
                // })
            },
        }
    }


</script>
<style scoped>

</style>